import React from 'react';
import { CheckCircle2 } from 'lucide-react';

const WhyTraainConsultants = () => {
  const capabilities = [
    'Deliver branded Traaining programs at scale',
    'Give clients unlimited AI-powered role-play',
    'Measure skill progression and impact',
    'Reduce live delivery time without reducing value',
    'Offer modern, turnkey enablement clients expect'
  ];

  return (
    <section className="py-24 px-6 bg-gradient-to-b from-transparent to-blue-950/20">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white">
            What Traain Unlocks for <span className="text-cyan-400">Consultants</span>
          </h2>
          <p className="text-xl text-gray-300">
            With Traain, you can:
          </p>
        </div>

        <div className="max-w-3xl mx-auto mb-12">
          <div className="space-y-4">
            {capabilities.map((capability, index) => (
              <div
                key={index}
                className="flex items-start gap-4 p-6 rounded-xl bg-gradient-to-br from-gray-900/80 to-blue-900/20 border border-cyan-500/30 hover:border-cyan-400/60 transition-all duration-300"
              >
                <CheckCircle2 className="w-6 h-6 text-cyan-400 flex-shrink-0 mt-1" />
                <p className="text-lg text-gray-300">{capability}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center">
          <div className="inline-block p-8 rounded-2xl bg-gradient-to-br from-cyan-900/20 to-blue-900/30 border border-cyan-500/30">
            <p className="text-2xl font-bold text-white mb-2">
              You bring the expertise.
            </p>
            <p className="text-xl text-cyan-400">
              Traain brings the engine that scales it.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyTraainConsultants;
